import {
    getFooterContent,
    getFooterProfile,
    getFooterPosition,
    getFooterRightContainerContent,
    getFlipToolbarVertically,
    getHeaderContent,
    getHeaderProfile,
    getHeaderLeftContainerContent,
    getHeaderPosition,
    getHeaderRightContainerContent,
    getNoHideFooter,
    getNoHideHeader,
    getNoHideToolbar,
    getToolbarContent,
    getToolbarPosition,
} from '../shared/layout-dynamics'

export const toolbarsState = {
    defaultState: (path = window.location.pathname) => ({
        floatingHeader: true,
        floatingHeaderPosition: getHeaderPosition(path),
        headerProfile: getHeaderProfile(path),
        headerContent: getHeaderContent(path),
        headerLeftContainerContent: getHeaderLeftContainerContent(path),
        headerRightContainerContent: getHeaderRightContainerContent(path),
        floatingFooter: true,
        floatingFooterPosition: getFooterPosition(path),
        footerProfile: getFooterProfile(path),
        footerContent: getFooterContent(path),
        footerRightContainerContent: getFooterRightContainerContent(path),
        floatingToolbar: true,
        floatingToolbarPosition: getToolbarPosition(path),
        flipToolbarVertically: getFlipToolbarVertically(path),
        toolbarContent: getToolbarContent(path),
        noHideHeader: getNoHideHeader(path),
        noHideFooter: getNoHideFooter(path),
        noHideToolbar: getNoHideToolbar(path),
    }),
    actions: {
        enableFloatingHeader: (_, state) => ({...state, floatingHeader: true}),
        disableFloatingHeader: (_, state) => ({...state, floatingHeader: false}),
        setHeader: ({position, profile, content, leftContainerContent, rightContainerContent, columnCount}, state) => ({
            ...state,
            floatingHeaderPosition: position,
            headerProfile: profile,
            headerContent: content ?? null,
            headerLeftContainerContent: leftContainerContent ?? null,
            headerRightContainerContent: rightContainerContent ?? null,
            headerColumnCount: columnCount,
        }),
        enableFloatingFooter: (_, state) => ({...state, floatingFooter: true}),
        disableFloatingFooter: (_, state) => ({...state, floatingFooter: false}),
        setFooter: ({position, profile, content, rightContainerContent, color, columnCount}, state) => ({
            ...state,
            floatingFooterPosition: position,
            footerProfile: profile,
            footerContent: content ?? null,
            footerRightContainerContent: rightContainerContent ?? null,
            footerColor: color,
            footerColumnCount: columnCount,
        }),
        enableFloatingToolbar: (_, state) => ({...state, floatingToolbar: true}),
        disableFloatingToolbar: (_, state) => ({...state, floatingToolbar: false}),
        setToolbar: ({position, content, columnCount, flipVertically}, state) => ({
            ...state,
            floatingToolbarPosition: position,
            flipToolbarVertically: flipVertically,
            toolbarContent: content ?? null,
            toolbarColumnCount: columnCount,
        }),
        setNoHideHeader: (value, state) => ({...state, noHideHeader: value}),
        setNoHideFooter: (value, state) => ({...state, noHideFooter: value}),
        setNoHideToolbar: (value, state) => ({...state, noHideToolbar: value}),
    },
}
